import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function DriverSidePhoto() {
  return <PhotoLayout {...photoLayoutConfig['driverside']} />;
}
